<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0':'pr-0'">
  @if (!isMobile) {
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'MyCoresNavNode'"
      [childNavState]="'CoreReportsNavNode'"></app-my-account-left-sidenav>
    </div>
  }
  <div class="containerheader my-account-right-nav"
    [ngClass]="isMobile? 'col-12 px-0' :'col-12 col-sm-12 col-md-12 col-lg-9 pr-0'">
    @if (getApi$|async; as coreReport) {
      <h1 class="myProfileTopHeader m-0 dialogHeader">{{'common.basket_export_user_core'|cxTranslate}}</h1>
      <div class="myProfileBody core-searchBody">
        <p><strong>{{'common.core_report_NA_description'|cxTranslate}}</strong></p>
        <p>{{'common.core_report_NA_description_example'|cxTranslate}}</p>
        <div class="formdiv">
          <div class="customerId">
            <label for="customerid">{{'common.core_report_parent'|cxTranslate}}</label>
            @if (selectedCustomerID == undefined ) {
              <div class="selectbox customdiv" (click)="showChild = !showChild" [(ngModel)]="selectedCustomerID">
                <span>{{ coreReport?.addressList[0]?.sapCustomerID }}&nbsp;|&nbsp;{{
                  coreReport?.addressList[0]?.companyName}}&nbsp;|&nbsp;
                {{ coreReport?.addressList[0]?.formattedAddress}}</span>
              </div>
            } @else {
              <div class="selectbox customdiv" (click)="showChild = !showChild" [(ngModel)]="selectedCustomerID">
                <span>{{ selectedCustomerID?.sapCustomerID }}&nbsp;|&nbsp;{{
                  selectedCustomerID?.companyName}}&nbsp;|&nbsp;
                {{ selectedCustomerID?.formattedAddress}}</span>
              </div>
            }
            @if (showChild) {
              <div class="customer_id_container" [ngClass]="isMobile ? 'custom-width' : 'desktop-width'">
                <div class="searchBoxdiv">
                  <input type="text" class="Cust_ID_search"
                    placeholder="{{ 'common.emea_core_customer_id_placeholder' | cxTranslate }}" name="searchInput"
                    [(ngModel)]="searchInput" />
                  </div>
                  <div class="customer_id_div">
                    @for (data of coreReport?.addressList | filter: searchInput; track data; let i = $index) {
                      <div class="customer_ID_Li">
                        <div class="customer_id_list" (click)="selectedsoldTo(data)">
                          {{ data?.sapCustomerID }}&nbsp;|&nbsp; {{ data?.companyName}}&nbsp;|&nbsp;
                          {{ data?.formattedAddress }}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <br />
            <div class="buttoncontainercorereports">
              <div class="row core_report_style">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 core-report_monthyear">
                  <div class="month-year">
                    <label for="month">{{'common.core_report_date'|cxTranslate}}</label>
                    <div class="selectbox ">
                      <select class="monthSelect" #monthyear (change)="monthselectyear(monthyear.value)">
                        @for (data of coreReport.months.entry; track data) {
                          <option [value]="data.key">{{data.value}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 ">
                  <div class="file-format">
                    <label for="file" class="file">{{'common.core_report_format'|cxTranslate}}</label>
                    <div class="selectbox ">
                      <select class="monthSelect" #filetype (change)="fileselecttype(filetype.value)">
                        @for (filetype of coreReport.format; track filetype) {
                          <option>{{filetype}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <button class="btn btn-primary core-report_submitbutton btn-submit" type="submit"
                    (click)="postApiCall(coreReport?.addressList[0],coreReport?.months?.entry[0],coreReport?.format[0])">{{'common.mobile_checkout_multi_button_submit'|cxTranslate}}
                    <img class="img-hover" src="/icons/link-grey.svg" width="20px" alt=""></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (fileCards && fileCards?.length>=0) {
            <div class="row d-flex justify-content-between report-container">
              @for (file of fileCards; track file) {
                @if (file.key==='SUMMARY') {
                  <div class="coreCardContainerDiv">
                    <div class="corecardHeader">
                      <div class="fsbig">{{'common.text_reports_summary'|cxTranslate}}</div>
                      <div class="fslow">{{'common.text_reports_summaryEmea'|cxTranslate}}</div>
                    </div>
                    @if (fileCards[0].value.indexOf('.pdf')>-1) {
                      <div class="imgpdf"><img src="/icons/pdf-grey.svg"
                      width="80px" alt=""></div>
                    }
                    @if (fileCards[0].value.indexOf('.xls')>-1) {
                      <div class="imgpdf"><img src="/icons/xls_icon.svg"
                      width="80px" alt=""></div>
                    }
                    <div class="buttondiv">
                      <a target="_blank"
                        [href]="file.value.indexOf('.xls')>-1?baseUrl + file.value:baseUrl + file.value.split('&attach')[0]">
                        <button class="btn btn-primary">{{'common.text_reports_download'|cxTranslate}}<img
                        src="/icons/link-white.svg" width="20px" alt=""></button>
                      </a>
                    </div>
                  </div>
                }
                @if (file.key==='DETAIL') {
                  <div class="coreCardContainerDiv">
                    <div class="corecardHeader">
                      <div class="fsbig">{{'common.text_reports_detail'|cxTranslate}}</div>
                      <div class="fslow">{{'common.text_reports_detailEmea'|cxTranslate}}</div>
                    </div>
                    @if (fileCards[0].value.indexOf('.pdf')>-1) {
                      <div class="imgpdf"><img src="/icons/pdf-grey.svg"
                      width="80px" alt=""></div>
                    }
                    @if (fileCards[0].value.indexOf('.xls')>-1) {
                      <div class="imgpdf"><img src="/icons/xls_icon.svg"
                      width="80px" alt=""></div>
                    }
                    <div class="buttondiv">
                      <a target="_blank"
                        [href]="file.value.indexOf('.xls')>-1?baseUrl + file.value:baseUrl + file.value.split('&attach')[0]">
                        <button class="btn btn-primary">{{'common.text_reports_download'|cxTranslate}}<img
                        src="/icons/link-white.svg" width="20px" alt=""></button>
                      </a>
                    </div>
                  </div>
                }
                @if (file.key==='CREDIT') {
                  <div class="coreCardContainerDiv">
                    <div class="corecardHeader">
                      <div class="fsbig">{{'common.text_reports_credit'|cxTranslate}}</div>
                      <div class="fslow">{{'common.text_reports_creditEmea'|cxTranslate}}</div>
                    </div>
                    @if (fileCards[0].value.indexOf('.pdf')>-1) {
                      <div class="imgpdf"><img src="/icons/pdf-grey.svg"
                      width="80px" alt=""></div>
                    }
                    @if (fileCards[0].value.indexOf('.xls')>-1) {
                      <div class="imgpdf"><img src="/icons/xls_icon.svg"
                      width="80px" alt=""></div>
                    }
                    <div class="buttondiv">
                      <a target="_blank"
                        [href]="file.value.indexOf('.xls')>-1?baseUrl + file.value:baseUrl + file.value.split('&attach')[0]">
                        <button class="btn btn-primary">{{'common.text_reports_download'|cxTranslate}}<img
                        src="/icons/link-white.svg" width="20px" alt=""></button>
                      </a>
                    </div>
                  </div>
                }
              }
            </div>
          }
          <p class="bottomptag">{{'common.test_account_core_reportsinfoNA'|cxTranslate}} <a class="mail-link"
          href="mailto:cores@bendix.com">cores&#64;bendix.com.</a></p>
        }
      </div>
    </div>